import { Host, useHost } from "host/host";
import win from "./win.module.css";

const getHeaderHostStyle = (host: Host) => {
    switch (host) {
        case "web":
            return { container: "", main: "", more: "", box: "" };
        case "mac": {
            const { container, main, more, box } = win;
            return { container, main, more, box };
        }
        case "win": {
            const { container, main, more, box } = win;
            return { container, main, more, box };
        }
    }
};

export const useHeaderHostStyle = () => getHeaderHostStyle(useHost());
